export const COMPETITION_ID = '-Oj5pVJigoBj36A0mt2X';
